// ============================================
// FILE: src/components/ServiceCard.jsx
// ============================================

import React from 'react';

const ServiceCard = ({ icon, title, description, gradient, borderColor }) => {
  return (
    <div 
      className="group relative bg-white rounded-2xl p-6 shadow-md hover:shadow-2xl transition-all duration-500 ease-out cursor-pointer border border-gray-100 hover:border-gray-200 h-full"
      style={{
        borderTop: `3px solid ${borderColor || '#c49404ff'}`,
        borderLeft: '1px solid #f0f0f0',
        borderRight: '1px solid #f0f0f0',
        borderBottom: '1px solid #f0f0f0'
      }}
    >
      {/* Animated background on hover */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-50 to-white rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
      
      <div className="relative z-10">
        {/* Icon container with enhanced hover effects */}
        <div 
          className={`w-16 h-16 mx-auto rounded-xl flex items-center justify-center mb-5 shadow-md group-hover:shadow-xl group-hover:scale-110 transition-all duration-500 ease-out group-hover:rotate-3`}
          style={{
            background: gradient || 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
          }}
        >
          <div className="transform transition-transform duration-300 group-hover:scale-105 flex items-center justify-center">
            {icon}
          </div>
        </div>

        {/* Title */}
        <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-gray-900 transition-colors duration-300 text-center">
          {title}
        </h3>

        {/* Description */}
        <p className="text-gray-500 leading-relaxed group-hover:text-gray-600 transition-colors duration-300 text-center">
          {description}
        </p>

        {/* Decorative line on hover */}
        <div className="w-12 h-0.5 bg-gray-200 mx-auto mt-4 group-hover:w-16 group-hover:bg-gradient-to-r from-blue-500 to-purple-500 transition-all duration-500"></div>
      </div>
    </div>
  );
};

export default ServiceCard;